export default {
  noResultMessage: 'Aucun résultat trouvé',
  serverError: 'Désolé, un problème est survenu lors de la requête.',
  networkError: 'Désolé, il semble y avoir un problème avec votre connexion.',
  tryAgain: ' Veuillez réessayer plus tard.',
};
